
import { useRuntimeStore } from '@/store/runtime'

export default function group (the_group) {
    
    // the_group is required
    
    const runtimeStore = useRuntimeStore()
    if (!runtimeStore.session) return false

    return runtimeStore.session.groups.includes(the_group)
}
